<template>
  <!--<div class="jp-com-tooltip-container">-->
    <!--鼠标滑过显示更多-->
    <el-tooltip
      effect="light"
      :placement="placement"
      ref="jsRefCommonTooltip"
      :content="content"
      :open-delay="500"
      popper-class="jp-common-tooltip"></el-tooltip>
  <!--</div>-->
</template>

<script>
export default {
  name: 'tooltip.vue',
  data() {
    return {
      // 提示内容
      content: '',
      // 提示方向
      placement: 'top'
    };
  },
  methods: {
    // 更新提示内容
    updateContent(params) {
      this.content = params.hasOwnProperty('content') ? params.content : '';
      this.placement = params.hasOwnProperty('placement') ? params.placement : 'top';
      this.$refs.jsRefCommonTooltip.currentPlacement = this.placement;
    }
  }

};
</script>

<style scoped>

</style>
